export default ['coolmathgames.com'];
